import React from "react";
import { Button, Icon, Input } from "antd";
import Form from "rc-field-form";
import styles from "./index.module.scss";
import Space from "../../../../../components/Space";
import { isTrue } from "../../../../../Utils/filter";
import useModalHandler from "../../../../../Utils/v3/useModalHandler";
import EditAksModal from "../../../Components/EditAksModal";
import Config from "../../../../../config";
import useBatchPicker from "../../../../main/utils/useBatchPicker";

interface QueryFormProps {
    onChange(keyword: string): void;
    setSort: (sort: BooleanValue) => void;
    sort: BooleanValue;
    reload: () => void;
}

export default function QueryForm({
    onChange,
    sort,
    setSort,
    reload
}: QueryFormProps) {
    function toggle() {
        setSort(isTrue(sort) ? "0" : "1");
    }

    const editModal = useModalHandler({
        component: EditAksModal
    });

    const { batch } = useBatchPicker();

    function openModal() {
        editModal.open({
            batchNo: batch!,
            customerCode: Config.CustomCode,
            onSuccess: () => {
                editModal.close();
                reload();
            }
        });
    }

    return (
        <div className={styles.root}>
            <Space>
                <Button type="link" size="small" onClick={toggle}>
                    时间排序
                    <Icon
                        type={
                            isTrue(sort) ? "sort-ascending" : "sort-descending"
                        }
                    />
                </Button>
            </Space>
            <div className={styles.rig}>
                <Form
                    className={styles.search}
                    onFinish={data => onChange(data.keyword)}>
                    <Form.Field name="keyword">
                        <Input
                            placeholder="请输入课程名称、课编号或问题关键字搜索"
                            maxLength={100}
                        />
                    </Form.Field>

                    <Button type="primary" htmlType="submit">
                        查询
                    </Button>
                </Form>

                <Button
                    type="primary"
                    ghost
                    className={styles.btnAsk}
                    onClick={openModal}>
                    提问
                </Button>
            </div>

            {editModal.render()}
        </div>
    );
}
